import {
    Flex,
    FormControl,
    FormLabel,
    TextProps as ChakraTextProps,
    Text,
    Tooltip,
    Icon,
  } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";
  
  interface TextProps extends ChakraTextProps {
    infoTooltipLabel?: string;
    infoTooltip?: boolean;
    error?: boolean;
    errorMessage?: string;
    register?: any;
    classInput?: string;
    before?: string;
    after?: string;
    label?: string;
    labelColor?: string;
    ref?: any;
    name?: string;
  }
  
  const StatusText = ({
    infoTooltipLabel,
    infoTooltip,
    labelColor,
    label,
    children,
    className,
    classInput,
    ref,
    register,
    error,
    errorMessage,
    before,
    after,
    name,
    ...rest
  }: TextProps) => {
    return (
      <FormControl>
        {label && (
          <FormLabel
            w="100%"
            color={labelColor ? labelColor : "gray.400"}
            fontSize="12px"
            marginBottom="0"
          >
            {label}
            {infoTooltip && (
              <Tooltip placement="top" hasArrow label={infoTooltipLabel}>
                <span>
                    <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                </span>
              </Tooltip>
            )}
          </FormLabel>
        )}
        <Flex align="center">
          <Text
            {...rest}
            name={name}
            borderRadius="2px"
            fontSize="16px"
          >
            {children}
          </Text>
        </Flex>
        {error && (
          <Text color="danger" mb="4" role="alert" _hover={{cursor: "pointer"}}>
              <Tooltip placement="bottom" hasArrow label={errorMessage}>
                  Motivo do error
              </Tooltip>
          </Text>
        )}
      </FormControl>
    );
  };
  
  export { StatusText };